import React, { useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import useAuth from './useAuth';
import { useAPI } from './useApi';
import { useDispatch } from 'react-redux';
import { openSnackbar } from 'store/slices/snackbar';
import { KeyedObject } from 'types';
import TermsView from 'ui-component/TermsView';

// Handles where to show the terms.
// Element injected in MainLayout component (/src/layout/MainLayout/index)

const PathToKey = {
    '/profile': 'profile',
    '/dashboard': 'dashboard',
    '/requests': 'requests',
    '/home': 'my_accounts',
    '/deposits': 'deposit',
    '/withdrawals': 'withdraw',
    '/transactions': 'transactions',
    '/downloads': 'downloads',
    '/support': 'support',
    '/compliance': 'documents'
};

function useTerms() {
    let location = useLocation();
    let { terms, acceptTerms } = useAuth();
    let api = useAPI('clients-terms-handler');
    let dispatch = useDispatch();
    let dispatchOpenSnackbar = (options: KeyedObject) => {
        dispatch(openSnackbar(options));
    };
    let path = location.pathname;
    let view = useMemo(() => {
        if (terms) {
            let keys = Object.keys(PathToKey).filter((item) => item.includes(path));
            let key: string = '';
            if (keys.length > 0) {
                let pathKey = keys[0] as keyof typeof PathToKey;
                key = PathToKey[pathKey];
            }
            let forSection = terms.filter(
                (item) => item.blocked_portal_sections.includes('all') || item.blocked_portal_sections.includes(key)
            );
            if (forSection.length > 0) {
                let first = forSection[0];
                return <TermsView key={first._id} item={first} api={api} openSnackbar={dispatchOpenSnackbar} acceptTerms={acceptTerms} />;
            }
        }
        return null;
    }, [path, terms]);
    return view;
}

export default useTerms;
